import React from 'react';
import { Link } from 'react-router-dom';
import { isImmutable } from 'immutable';
import classNames from 'classnames';
import { Icon } from '../Icon';

const isFiltering = appliedFilters =>
  appliedFilters.some(
    filterValue =>
      isImmutable(filterValue)
        ? filterValue.get('value') !== ''
        : !!filterValue,
  );

export const generateEmptyBodyRow = ({
  loadingMessage = 'Loading items...',
  noSearchResultsMessage = 'No items were found - please modify your search criteria.',
  noItemsMessage = 'There are no items to display.',
  noItemsLinkTo = null,
  noItemsLinkToMessage = 'Add new item',
  errorMessage = 'There was a problem loading information from the server!',
  divMode = false,
} = {}) => props => {
  // Because most uses wont pass renderOptions or renderOptions won't contain
  // `addAuthorized` we explicitly check for `false` not any falsey value.
  const addAuthorized =
    !props.renderOptions || props.renderOptions.addAuthorized !== false;

  const content = props.loading ? (
    /* Visible if there are no items in the list and your table is loading or initializing data. */
    loadingMessage
  ) : props.error ? (
    props.error.message ? (
      <>
        {errorMessage} <br /> <small>({props.error.message})</small>
      </>
    ) : (
      <>{errorMessage}</>
    )
  ) : isFiltering(props.appliedFilters) ? (
    /* Visible if there are no items in the list and you have filter criteria */
    noSearchResultsMessage
  ) : (
    /* Visible if there are no items in the list and you are not searching */
    <>
      {noItemsMessage}{' '}
      {addAuthorized && noItemsLinkTo ? (
        typeof noItemsLinkTo === 'function' ? (
          <button className="btn btn-text" onClick={noItemsLinkTo}>
            {noItemsLinkToMessage}
          </button>
        ) : (
          <Link to={noItemsLinkTo}>
            <Icon name="plus" md />
            <span>{noItemsLinkToMessage}</span>
          </Link>
        )
      ) : null}
    </>
  );
  return divMode ? (
    <div className="no-data">{content}</div>
  ) : (
    <tr>
      <td
        colSpan={props.colSpan}
        className={classNames('no-data', {
          'no-data--loading': props.loading,
          'no-data--error': props.error,
        })}
      >
        {content}
      </td>
    </tr>
  );
};

export const EmptyBodyRow = generateEmptyBodyRow();
